var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminReviewsIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7502 2.96532L15.1877 7.88319C15.3098 8.13125 15.5455 8.30436 15.8192 8.34447L21.2763 9.13509C21.4973 9.16464 21.6962 9.28076 21.832 9.45809C22.0867 9.79059 22.0478 10.2614 21.7425 10.5474L17.7873 14.3833C17.5863 14.5733 17.4968 14.852 17.5495 15.1233L18.4967 20.5362C18.563 20.9848 18.2578 21.4049 17.8105 21.4778C17.6252 21.5063 17.4358 21.4767 17.2674 21.3933L12.4071 18.8378C12.1629 18.7048 11.8703 18.7048 11.6261 18.8378L6.72998 21.4071C6.32056 21.6161 5.81958 21.4609 5.59646 21.0587C5.51121 20.8962 5.48174 20.7114 5.51121 20.5309L6.45844 15.118C6.5058 14.8478 6.41634 14.5702 6.22058 14.3791L2.24431 10.5443C1.92015 10.2213 1.91804 9.69559 2.24115 9.37048C2.24221 9.36942 2.24326 9.36731 2.24431 9.36626C2.37798 9.24487 2.54216 9.16359 2.72003 9.13192L8.17819 8.3413C8.45078 8.29803 8.68548 8.12702 8.80968 7.87897L11.2451 2.96532C11.343 2.76582 11.5167 2.61277 11.7271 2.5431C11.9387 2.47238 12.1702 2.48927 12.3692 2.58954C12.5323 2.67082 12.666 2.80277 12.7502 2.96532Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminReviewsIconFilled);
export default __webpack_public_path__ + "static/media/admin-reviews-icon-filled.86f62400f42495905a584775d12fcdbd.svg";
export { ForwardRef as ReactComponent };